import { Field, Formik } from "formik";
import { TextField } from "formik-mui";
import React, { useEffect, useState } from "react";
import ProfilePhoto from "../../../assets/svg/profile.svg";
import Mark from "../../../assets/svg/mark.svg";
import { useSelector } from "react-redux";
import { initialProfileValues, ProfileSchema } from "../../../schemas/ProfileSchema";
import Spinner from "../../Loader/Spinner";
import { useAuth } from "../../../context/AuthContext";
import Popup from "reactjs-popup";
import { auth } from "../../../firebase/firebase";
import useUploadImage from "../../../hooks/useUploadImage";
import { TbWorld } from "react-icons/tb";

const EditProfile = ({ close }) => {
  const [showPassword, setShowPassword] = useState(false);
  const { profile: userProfile } = useSelector((state) => state.authStore);
  const { updateUserProfile, loading, setIsPictureUpdated, setValues, done } = useAuth();
  const { handleClick, onChange, imageRef, image } = useUploadImage();
  const [userMail, setUserMail] = useState(userProfile.email);


  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const submitHandler = async (values) => {
    await updateUserProfile(false, true);
    setValues({ ...values, profilePicture: image.file || userProfile?.profilePicture });
    close();
  };
  const handleChange = (e, setFieldValue) => {
    setFieldValue("email", e.target.value);
    setUserMail(e.target.value);
  };

  useEffect(() => {
    if (image.file) {
      setIsPictureUpdated(true);
    }
  }, [image.file, setIsPictureUpdated]);

  useEffect(() => {
    if (done) {
      done && close();
    }
  }, [close, done]);

  return (
    <div className="w-full h-full flex flex-col items-center justify-center pb-10 px-20">
      <p className="text-[#1A1D4D] font-black text-[24px] pb-6 self-start">Profile Edit</p>
      <div className="w-full flex justify-between items-center">
        <div className="w-full flex items-center justify-start gap-5 ">
          <div className="flex items-center self-start justify-between">
            <img
              src={image.preview ? image.preview : userProfile?.profilePicture ? userProfile.profilePicture : ProfilePhoto}
              alt=""
              className=" h-[6rem] w-[6rem] bg-jumbleng-primary-light object-cover rounded-full"
            />
          </div>
          <button
            htmlFor="imageUpload"
            onClick={handleClick}
            className="w-[200px]  md:w-[120px] h-[50px] border  focus:outline-none  border-primary rounded text-primary text-[12px] flex items-center justify-center"
          >
            Change
          </button>
          <input id="imageUpload" type="file" accept="image/png, image/jpg, image/jpeg" className="w-0.1 h-0.1 overflow-hidden hidden" ref={imageRef} onChange={onChange} />
        </div>
        <Popup
          trigger={
            <div className="p-[9px] border rounded-full mx-5 cursor-pointer">
              <TbWorld className="text-xl text-primary" />
            </div>
          }
          position="bottom right"
          on={"click"}
          arrow={false}
          nested
          contentStyle={{
            padding: "10px",
            borderRadius: "12px",
            color: "#5E5BA7",
            width: "fit-content",
          }}
        >
          {(close) => (
            <div className="p-4">
              <div className="text-primary">
                <div className="flex justify-between items-center py-4 border-b-2 border-gray-200">
                  <div className="flex items-center gap-6 mr-16">
                    <img src="https://flagcdn.com/w2560/us.png" className="h-8 w-8 rounded-full" style={{
                      objecFit: 'cover',
                    }} alt="" />
                    <h4 className="text-sm font-semibold text-gray-800">
                      English
                    </h4>
                  </div>
                  <button className="rounded hover:bg-blue-500 hover:text-white transition ease-in-out delay-150 duration-150 px-4 h-6 border border-blue-500 text-blue-500 text-xs font-semibold">
                    change
                  </button>
                </div>

                <div className="flex justify-between items-center py-4 border-b-2 border-gray-200">
                  <div className="flex items-center gap-6 mr-16">
                    <img src="https://flagcdn.com/w2560/de.png" className="h-9 w-9 rounded-full" style={{
                      objecFit: 'cover',
                    }} alt="" />
                    <h4 className="text-sm font-semibold text-gray-800">
                      German
                    </h4>
                  </div>
                  <button className="rounded hover:bg-blue-500 hover:text-white transition ease-in-out delay-150 duration-150 px-4 h-6 border border-blue-500 text-blue-500 text-xs font-semibold">
                    change
                  </button>
                </div>

                <div className="flex justify-between items-center py-4 border-b-2 border-gray-200">
                  <div className="flex items-center gap-6 mr-16">
                    <img src="https://flagcdn.com/w2560/se.png" className="h-8 w-8 rounded-full" style={{
                      objecFit: 'cover',
                    }} alt="" />
                    <h4 className="text-sm font-semibold text-gray-800">
                      Swedish
                    </h4>
                  </div>
                  <button className="rounded hover:bg-blue-500 hover:text-white transition ease-in-out delay-150 duration-150 px-4 h-6 border border-blue-500 text-blue-500 text-xs font-semibold">
                    change
                  </button>
                </div>
              </div>
            </div>
          )}
         
        </Popup>
      </div>
      <Formik
        onSubmit={submitHandler}
        initialValues={{ ...initialProfileValues, ...userProfile }}
        enableReinitialize
        validationSchema={ProfileSchema}
      >
        {({ handleSubmit, values, setFieldValue }) => (
          <div className="w-full flex flex-col items-center justify-center ">
            <div className="pt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
              <>
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"firstName"}
                    label="First Name"
                    value={values.firstName || ""}
                    placeholder="John"
                    component={TextField}
                    className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                  <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute fa-solid fa-eye`} />
                </div>
              </>
              <>
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"lastName"}
                    label="Last Name"
                    placeholder="Doe"
                    value={values.lastName || ""}
                    component={TextField}
                    className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                  <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute fa-solid fa-eye`} />
                </div>
              </>
            </div>
            <div className="pt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
              <>
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"email"}
                    value={values.email || ""}
                    onChange={(e) => {
                      e.preventDefault();
                      handleChange(e, setFieldValue);
                    }}
                    label="Email"
                    placeholder="johndoe@email.com"
                    component={TextField}
                    className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                  <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute fa-solid fa-eye`} />
                </div>
              </>
              <>
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"phoneNumber"}
                    label="Phone"
                    placeholder="08123456789"
                    value={values.phoneNumber || ""}
                    component={TextField}
                    className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                  <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute fa-solid fa-eye`} />
                </div>
              </>
            </div>{" "}
            <div className="pt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
              <>
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"address"}
                    label="Address"
                    value={values.address || ""}
                    placeholder="312 Quilly Lane Worthington"
                    component={TextField}
                    className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                  <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
                </div>
              </>
              <>
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"zipCode"}
                    label="Zip Code"
                    value={values.zipCode || ""}
                    placeholder="1234567"
                    component={TextField}
                    className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                  <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
                </div>
              </>
            </div>
            <div className="pt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
              <>
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"city"}
                    label="City"
                    placeholder="City"
                    value={values.city || ""}
                    component={TextField}
                    className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                  <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
                </div>
              </>
              <>
                {" "}
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"state"}
                    label="State"
                    value={values.state || ""}
                    placeholder="New York"
                    component={TextField}
                    className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                  <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
                </div>
              </>
            </div>{" "}
            <div className="pt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
              <>
                {" "}
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"password"}
                    onKeyDown={(e) => {
                      e.key === "Enter" && handleSubmit();
                    }}
                    label="Password"
                    value={values.password || ""}
                    placeholder="*********"
                    component={TextField}
                    type={`${showPassword ? "text" : "password"}`}
                    className="border w-full md:w-[337px] border-primary  rounded px-2  focus:outline-none text-[14px] font-semibold "
                  />
                  <i
                    onClick={togglePassword}
                    className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute fa-solid fa-eye${showPassword ? "" : "-slash"}`}
                  ></i>
                </div>
              </>
              <>
                <div className="mt-1 relative flex md:justify-end">
                  <Field
                    name={"country"}
                    label="Country"
                    value={values.country || ""}
                    placeholder="USA"
                    component={TextField}
                    className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                  />
                  <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
                </div>
              </>
            </div>
            {auth?.currentUser?.email !== userMail ? (
              <Popup
                trigger={
                  <button className="w-[200px]  md:w-[120px] h-[50px] border mt-12 border-primary rounded text-primary text-[12px] flex items-center justify-center">
                    Update
                  </button>
                }
                position="right center"
                modal
                closeOnDocumentClick={true}
                nested
                contentStyle={{
                  borderRadius: "12px",
                  border: 0,
                  backgroundColor: "white",
                  width: "fit-content",
                  fontSize: "0.8rem",
                  maxHeight: "95%",
                  overflow: "auto",
                }}
              >
                {(close) => (
                  <div className="px-5 py-10">
                    <p className="text-[16px] text-center w-[400px]">
                      You would be required you to <b>sign in again</b> if you update your email, are you sure you want to perform this action?
                    </p>
                    <div className="flex gap-4 justify-center">
                      <button onClick={handleSubmit} className="w-[200px]  h-[50px] bg-primary rounded mt-12 text-white text-base font-semibold">
                        {loading ? <Spinner /> : "Yes "}
                      </button>
                      <button onClick={close} className="w-[200px] h-[50px] border border-primary rounded mt-12 text-primary text-base font-semibold">
                        No
                      </button>
                    </div>
                  </div>
                )}
              </Popup>
            ) : (
              <button
                onClick={handleSubmit}
                className="w-[200px]  md:w-[120px] h-[50px] border mt-12 border-primary rounded text-primary text-[12px] flex items-center justify-center"
              >
                {loading ? <Spinner /> : "Update "}
              </button>
            )}
          </div>
        )}
      </Formik>
    </div>
  );
};

export default EditProfile;
